// @file Permissions for whiteboard tools.
const WRITER_TOOL_IDS = [
  'select',
  'interact',
  'laser',
  'draw-1',
  'draw-2',
  'highlight',
  'eraser',
  'geo',
  'note',
  'arrow',
  'padlet-upload',
  'padlet-attachment',
  'text',
  'undo',
  'redo',
]
const VIEWER_TOOL_IDS = ['interact']
const CODE_MODE_TOOL_IDS = ['select']

export { CODE_MODE_TOOL_IDS, VIEWER_TOOL_IDS, WRITER_TOOL_IDS }
